export const BUSINESS_CONTACT_SETTINGS = 'businessContactSettigns';
export const INDIVIDUAL_SETTINGS = 'individualSettings';
export const PERSONAL_SETTINGS = 'personalSettings';
export const PROPERTY_SEARCH_SETTINGS = 'propertySearchSettings';
export const REPORT_SETTINGS = 'reportSettings';
export const CHANGE_PASSWORD = 'changePassword';
